import { render, staticRenderFns } from "./EditMachineStatus.vue?vue&type=template&id=47704a90&scoped=true"
import script from "./EditMachineStatus.vue?vue&type=script&lang=js"
export * from "./EditMachineStatus.vue?vue&type=script&lang=js"
import style0 from "./EditMachineStatus.vue?vue&type=style&index=0&id=47704a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47704a90",
  null
  
)

export default component.exports